function onLoad() {
    replaceIcon()
    addEventListeners()
}

function addEventListeners() {
    let detailsEl = document.getElementById('ProductBlockAccordionDetails-description_collapsible')
    let detailsButtonEl = document.getElementById('AccordionButton-Details')
    let descriptionEl = document.getElementById('ProductBlockAccordion-description_collapsible')
    let descriptionButtonEl = document.getElementById('AccordionButton-Description')

    if (detailsEl) {
        detailsEl.addEventListener('transitionend', ev => {
            if (detailsButtonEl.classList.contains('Collapsed')) {
                detailsButtonEl.classList.add('border')
            }
        })
        detailsEl.addEventListener('transitionstart', ev => {
            if (detailsButtonEl.classList.contains('border')) {
                detailsButtonEl.classList.remove('border')
            }    
        })
    }
    if (descriptionEl) {
        descriptionEl.addEventListener('transitionend', ev => {
            if (descriptionButtonEl.classList.contains('Collapsed')) {
                descriptionButtonEl.classList.add('border')
            } else {
                descriptionButtonEl.classList.remove('border')
            }
        })
        descriptionEl.addEventListener('transitionstart', ev => {
            if (descriptionButtonEl.classList.contains('border')) {
                descriptionButtonEl.classList.remove('border')
            }    
        })
    }
}

function replaceIcon() {
    let flickityEl = Array.from(document.getElementsByClassName('ProductGallery__Carousel'))
    if (!flickityEl.length) {
        setTimeout(replaceIcon, 250)
        return
    }

    let arrowIcons = Array.from(flickityEl[0].getElementsByClassName('flickity-button'))
    arrowIcons.forEach(buttonEl => {
        let which = buttonEl.classList.contains('previous') ? 'left' : 'right'
        buttonEl.innerHTML = `<div class="carat ${which}"></div>`
    })
}

window.onload = onLoad

onLoad()
